<template>
    <div class="plant-box">
        <el-row>
            <el-col :span="4">
                <div style="height: 100vh; padding: 25px; overflow-y: auto" >
                    <div style="margin-bottom: 10px">订单号：{{orderInfo.orderNo}}</div>
                    <div v-for="(item, index) in orderInfo.uploadList" :key="index" style="width: 100%">
                        <img :src="item" alt="" style="width: 100%; height: auto; margin-bottom: 10px">
                    </div>
                </div>

            </el-col>
            <el-col :span="20">
                <div style="height: 100vh; display: flex; flex-direction: column; align-items: center" >
                    <div style="height: 100px"></div>
                    <div style="width: 80%">
                        <el-upload
                                class="upload-demo"
                                drag
                                action="https://adminbaseapi.xoxq.com.cn/web/upload"
                                multiple
                                :on-success="uploadSuccess"
                                :on-remove="removeFunc"
                        >
                            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                            <div class="el-upload__text">
                                将文件拖到此处 <em>点击上传</em>
                            </div>
                            <template #tip>
                                <div class="el-upload__tip">
                                    jpg/png files with a size less than 500kb
                                </div>
                            </template>
                        </el-upload>
                    </div>

                    <el-button type="primary" style="width: 300px" @click="editOrderImageUpload">提交</el-button>

                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  name: 'HelloWorld'
}
</script>
<script setup>
    import { UploadFilled } from '@element-plus/icons-vue'
    import { ref } from 'vue'
    import axios from 'axios'
    import { ElMessage } from 'element-plus'

    // 优化的传统方法
    const getUrlParams = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};

        for (const [key, value] of searchParams) {
            params[key] = value;
        }

        return params;
    }

    // 获取单个参数
    const orderNo = ref(getUrlParams()['orderNo'])
    const token = ref(getUrlParams()['token'])
    const loading = ref(false)
    const orderInfo = ref({})
    const imageList = ref([])


    const getOrderDetails = async () => {
        loading.value = true
        try {
            const response = await axios.post('https://api.xoxq.com.cn/api/order/appointment/route/details',
                {
                    orderNo: orderNo.value
                },
                {
                    headers:{
                        "Authorization": `Bearer ${token.value}`
                    }
                }
            )
            orderInfo.value = response.data.data
            // console.log(response.data)
            // imageList.value.push(...response.data.data.uploadFiles)
        } catch (error) {
            console.error('获取数据失败:', error)
        } finally {
            loading.value = false
        }
    }

    const editOrderImageUpload = async () => {
        console.log(orderInfo.value)
        if(!orderInfo.value.attractions){
            ElMessage({ type: 'error', message: `没有景点信息` })
            return
        }
        if(imageList.value.length == 0){
            ElMessage({ type: 'error', message: `没有上传的图片` })
            return
        }
        try {
            const response = await axios.post('https://api.xoxq.com.cn/api/account/user/attraction/upload',
                {
                    id: orderInfo.value.attractions[0].id,
                    daysSort: 1,
                    attractionUpload: imageList.value.join(',')
                },
                {
                    headers:{
                        "Authorization": `Bearer ${token.value}`
                    }
                }
            )
            if(response.data.code == 200){
                imageList.value = []
                ElMessage({ type: 'success', message: `上传成功` })
                getOrderDetails()
            }
        } catch (error) {
            console.error('获取数据失败:', error)
        } finally {
            loading.value = false
        }
    }
    getOrderDetails()


    const uploadSuccess = (e) => {
        console.log(e)
        imageList.value.push(e.data.file.url)
    }
    const removeFunc = (e) => {
        const index = imageList.value.indexOf(e.response.data.file.url);
        if (index > -1) {
            imageList.value.splice(index, 1);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .plant-box{
        width: 100%;
        height: 100vh;
    }
</style>
